
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { DemoRequestForm } from './DemoRequestForm';
import { X } from 'lucide-react';

interface DemoRequestDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DemoRequestDialog({ open, onOpenChange }: DemoRequestDialogProps) {
  const handleSuccessfulSubmission = () => {
    // Dialog will automatically close when redirected to success page
    onOpenChange(false);
  };
  
  const handleClose = () => {
    onOpenChange(false);
  };
  
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[540px] p-6 rounded-lg" hideCloseButton>
        <DialogHeader className="text-left space-y-3">
          <div className="flex items-center justify-between">
            <DialogTitle className="text-2xl font-medium">Request a Demo</DialogTitle>
            <button 
              onClick={handleClose} 
              className="rounded-full p-1 hover:bg-accent transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <DialogDescription className="text-base">
            Fill out the form below to schedule a personalized demo of our platform.
          </DialogDescription>
        </DialogHeader>
        <DemoRequestForm onSuccess={handleSuccessfulSubmission} />
      </DialogContent>
    </Dialog>
  );
}
